import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import users from './modules/users'
// import categories from './modules/categories'
// import products from './modules/products'
import dashboard from './modules/dashboard'
// import message from './modules/message'
// import videos from './modules/videos'
// import orders from './modules/orders'
// import gallery from './modules/gallery'
import notifications from './modules/notifications'
// import threads from './modules/threads'
// import clients from './modules/clients'
// import statement from './modules/statement'
// import questions from './modules/questions' 
// import testQuestions from './modules/testQuestions'
// import exams from './modules/exams'
import citizens from './modules/citizens'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    users,
    dashboard,
    notifications,
    citizens
  },
  state: {
    /* User */
    userName: null,
    userEmail: null,
    userAvatar: null,
    noOfUnreadNotifications: 0,
    /* NavBar */
    isNavBarVisible: true,

    /* FooterBar */
    isFooterBarVisible: true,

    /* Aside */
    isAsideVisible: true,
    isAsideMobileExpanded: false
  },
  mutations: {
    /* A fit-them-all commit */
    basic(state, payload) {
      state[payload.key] = payload.value
    },

    isNavBarVisible(state, show){
      state.isNavBarVisible = show;
    },
    /* User */
    user(state, payload) {
      if (payload.name) {
        state.userName = payload.name
      }
      if (payload.email) {
        state.userEmail = payload.email
      }
      if (payload.avatar) {
        state.userAvatar = payload.avatar
      }
    },

    /* Aside Mobile */
    asideMobileStateToggle(state, payload = null) {
      const htmlClassName = 'has-aside-mobile-expanded'

      let isShow

      if (payload !== null) {
        isShow = payload
      } else {
        isShow = !state.isAsideMobileExpanded
      }

      if (isShow) {
        document.documentElement.classList.add(htmlClassName)
      } else {
        document.documentElement.classList.remove(htmlClassName)
      }

      state.isAsideMobileExpanded = isShow
    }
  },
  actions: {
    updateNumberOfNotification({ state, commit }, number) {
      return this.state.noOfUnreadNotifications = number
    }
  }
})
